import { Button, Box, FormControl, Input, InputLabel, TableHead, Stack, Table, TablePagination, Typography, Select, MenuItem, Grid } from '@mui/material'
import React, { useCallback, useRef, useEffect, useState } from 'react'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import ActionsBar from '../../../components/ActionsBar';
import { Download, FilterAlt } from '@mui/icons-material'
import TextField from '@mui/material/TextField/TextField';
import Paper from '@mui/material/Paper'
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import OrderItem from './components/OrderItem';
import { styled } from '@mui/material/styles'
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { authAtom, serviceGroupsAtom, shopsAtom, staffsAtom, tokenAtom } from '../../../actions';
import { useAtom, useAtomValue } from 'jotai';
import axios from 'axios';
import dayjs from 'dayjs';
import DateRangeModal from '../Payments/modals/DateRangeModal';
import AddComissionModal from '../Leads/modals/AddComissionModal';
import { toast } from 'react-toastify';
import { hasPermission, showConfirmationToast, convertMoney, getOrderId, LEAD_ORDER_STATUS, LEAD_ORDER_PAYMENT_STATUS } from '../../../utils/utils';
import * as XLSX from 'xlsx'
import { MultiSelect } from "react-multi-select-component";
import FilterModal from './components/FilterModal';
import ActiveFilters from './components/ActiveFilters';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        zIndex: 1
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const Screen = () => {
    const [orders, setOrders] = useState([])
    const shops = useAtomValue(shopsAtom)
    const [token] = useAtom(tokenAtom)
    const [total, setTotal] = useState(0)
    const [totalPayment, setTotalPayment] = useState(0)
    const [totalPrice, setTotalPrice] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(50)
    const [page, setPage] = useState(0)
    const [dateRangeModal, setDateRangeModal] = useState(false)
    const [startDate, setStartDate] = useState(dayjs().subtract(90, 'days').format())
    const [endDate, setEndDate] = useState(dayjs().format())
    const [shop, setShop] = useState(0)
    const [keyword, setKeyword] = useState('');
    const [status, setStatus] = useState(null)
    const [serviceGroup, setServiceGroup] = useState(null)
    const [serviceType, setServiceType] = useState('all')
    const staffs = useAtomValue(staffsAtom)
    const [selectedStaffs, setSelectedStaffs] = useState([])
    const authUser = useAtomValue(authAtom)
    const [changeComission, setChangeComissionModal] = useState(null)
    const toastId = useRef(null)
    const timeoutRef = useRef(null);
    const [debouncedKeyword, setDebouncedKeyword] = useState('');
    const [loading, setLoading] = useState(true)
    const [filterModalOpen, setFilterModalOpen] = useState(false);
    const serviceGroups = useAtomValue(serviceGroupsAtom)

    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            setDebouncedKeyword(keyword);
        }, 500);

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [keyword]);

    const onChangeRange = (range) => {
        setStartDate(range.startDate)
        setEndDate(range.endDate)
        setDateRangeModal(false)
    }

    const refreshOrder = useCallback(() => {
        console.log({ token })
        if (token) {
            setLoading(true)
            axios.defaults.headers.common['Authorization'] = `Token ${token}`
            setOrders([])
            setTotal(0)
            setTotalPayment(0)
            setTotalPrice(0)

            axios.post('/booking/lead_order/all_orders/', {
                offset: page * rowsPerPage,
                limit: rowsPerPage,
                shop: shop > 0 ? shop : null,
                staffs: selectedStaffs.length > 0 ? selectedStaffs.map((item) => item.value) : null,
                status: status,
                service_group: serviceGroup,
                service_type: serviceType !== 'all' ? serviceType : null,
                from_date: dayjs(startDate).startOf('day').format(), 
                to_date: dayjs(endDate).endOf('day').format(),
                keyword: debouncedKeyword.replace(/#/g, '')
            })
                .then((response) => {
                    setLoading(false)
                    if (response && response.data) {
                        setOrders(response.data.orders)
                        setTotal(response.data.total)
                        setTotalPayment(response.data.totalPayment ?? 0)
                        setTotalPrice(response.data.totalPrice ?? 0)
                    }
                })
                .catch((error) => {
                    console.log({ error })
                    setLoading(false)
                })
        }
    }, [token, page, rowsPerPage, startDate, endDate, selectedStaffs, debouncedKeyword, shop, status, serviceGroup, serviceType])

    useEffect(() => {
        refreshOrder()
    }, [refreshOrder])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeKeyword = (e) => {
        setPage(0)
        setKeyword(e.target.value)
    }

    const onChangeComission = ({ order_id, sale1, sale2, telesale }) => {
        axios.post('/booking/comissions/update_comission/', {
            order_id, sale1, sale2, telesale
        })
            .then((response) => {
                if (response && response.data) {
                    const filter = orders.filter((item) => item.id === order_id)
                    if (filter && filter.length > 0) {
                        const index = orders.indexOf(filter[0])
                        const newOrders = orders
                        let newOrder = orders[index]
                        newOrder.comission = response.data
                        newOrders.splice(index, 1, newOrder)
                        setOrders(newOrders)
                    }
                    toast.success('Xác nhận thành công')
                    setChangeComissionModal(null)
                } else {
                    toast.error('Cập nhật thất bại')
                }
            })
            .catch((error) => {
                if (error && error.response && error.response.data && error.response.data.message)
                    toast.error(error.response.data.message)
                else
                    toast.error('Cập nhật thất bại')
            })
    }

    const onDownload = () => {
        showConfirmationToast(`Chắc chắn tải về danh sách đơn hàng từ ${dayjs(startDate).format('DD/MM/YYYY')} đến ${dayjs(endDate).format('DD/MM/YYYY')}?`,
            () => {
                setTimeout(() => {
                    toastId.current = toast.loading("Đang tải dữ liệu")
                    axios.post('/booking/lead_order/download_all_orders/', {
                        shop: shop > 0 ? shop : null,
                        staffs: selectedStaffs.length > 0 ? selectedStaffs.map((item) => item.value) : null,
                        status: status,
                        from_date: dayjs(startDate).startOf('day').format(), to_date: dayjs(endDate).endOf('day').format(),
                        keyword: debouncedKeyword.replace(/#/g, '')
                    })
                        .then((response) => {
                            try {
                                if (response && response.data) {
                                    const report = response.data.map((item) => {
                                        let totalPrice = 0
                                        let totalPaid = 0
                                        const serviceName = item.orders.map((item) => item.service.name).join(', ')
                                        for (const orderItem of item.orders) {
                                            totalPrice += orderItem.price
                                        }
                                        for (const paymentItem of item.payments ?? []) {
                                            totalPaid += paymentItem.amount
                                        }

                                        return ({
                                            'order': getOrderId(item.id),
                                            'date': dayjs(item.order_date).format('HH:mm:ss DD/MM/YYYY'),
                                            'full_name': item.user.full_name,
                                            'username': item.user.username,
                                            'services': serviceName,
                                            'totalPrice': totalPrice ?? 0,
                                            'totalPaid': totalPaid ?? 0,
                                            'shop': item.shop ? item.shop.name : '',
                                            'status': LEAD_ORDER_PAYMENT_STATUS[item.payment_status],
                                            'sale1': item.sale1 ? item.sale1.full_name : '',
                                            'sale1Commission': item.comission && item.comission.sale1 ? item.comission.sale1 : 0,
                                            'sale2': item.sale2 ? item.sale2.full_name : '',
                                            'sale2Commission': item.comission && item.comission.sale2 ? item.comission.sale2 : 0,
                                            'telesale': item.telesale ? item.telesale.full_name : '',
                                            'telesaleCommission': item.comission && item.comission.telesale ? item.comission.telesale : 0,
                                        })
                                    })
                                    const worksheet = XLSX.utils.json_to_sheet(report, { origin: 'A2' });
                                    const headers = ['Đơn hàng', 'Ngày tạo đơn', "Khách hàng", 'Số điện thoại', 'Liệu trình', 'Tổng giá trị đơn', 'Đã thành toán', 'Cửa hàng', 'Trạng thái', 'Sale 1', 'Hoa hồng sale1', 'Sale 2', 'Hoa hồng sale2', 'Telesale', 'Hoa hồng telesale',]
                                    worksheet['!merges'] = [
                                        { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length } },
                                    ]
                                    XLSX.utils.sheet_add_aoa(worksheet, [[`Danh sách đơn hàng từ ${dayjs(startDate).format('DD/MM/YYYY')} đến ${dayjs(endDate).format('DD/MM/YYYY')}`]], { origin: "A1" });
                                    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A2" });
                                    const workbook = XLSX.utils.book_new();
                                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
                                    XLSX.writeFile(workbook, `Danh sách đơn hàng.xlsx`);

                                    toast.dismiss(toastId.current)
                                    toast.success('Tải về thành công')
                                }
                            } catch (error) {
                                console.log({ error })
                                toast.dismiss(toastId.current)
                                toast.error('Lỗi tải về')
                            }
                        })
                        .catch((error) => {
                            console.log({ error })
                            toast.dismiss(toastId.current)
                            toast.error('Lỗi tải về')
                        })
                }, 500);
            }, () => { })
    }

    const staffOptions = staffs.map((item) => ({ label: item.full_name, value: item.id }))
    // staffOptions.unshift({ label: 'Tất cả', id: 0 })

    const handleClearFilter = (type, value) => {
        switch (type) {
            case 'date':
                setStartDate(dayjs().subtract(90, 'days').format());
                setEndDate(dayjs().format());
                break;
            case 'status':
                setStatus(null);
                break;
            case 'staff':
                setSelectedStaffs(selectedStaffs.filter(staff => staff.value !== value));
                break;
            case 'serviceGroup':
                setServiceGroup(null);
                break;
            case 'serviceType':
                setServiceType('all');
                break;
            default:
                break;
        }
    };

    if (!(authUser && hasPermission(authUser, ['view_order', 'view_order_all']))) {
        return <Stack sx={{ flex: 1, alignItems: 'center', justifyContent: 'center', margin: '32px' }}>Không có quyền truy cập</Stack>
    }

    return (
        <Box style={{ flex: 1, display: 'flex', flexDirection: 'column', width: '100%' }}>
            <ActionsBar title='Danh sách đơn hàng' subTitle={`Tìm thấy ${total} đơn hàng`} />

            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginLeft: '24px', marginRight: '24px', gap: 2 }}>
                <FormControl sx={{ width: '300px' }} variant='outlined'>
                    <InputLabel>Tên khách hàng, số điện thoại</InputLabel>
                    <Input
                        value={keyword}
                        onChange={handleChangeKeyword}
                        placeholder="Tên khách hàng, số điện thoại"
                    />
                </FormControl>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button 
                        variant="outlined" 
                        startIcon={<FilterAlt />}
                        onClick={() => setFilterModalOpen(true)}
                    >
                        Bộ lọc
                    </Button>
                    {hasPermission(authUser, ['export_report_order']) && (
                        <Button onClick={onDownload}>
                            <Download />
                        </Button>
                    )}
                </Box>
            </Box>

            <ActiveFilters
                startDate={startDate}
                endDate={endDate}
                status={status}
                selectedStaffs={selectedStaffs}
                serviceGroup={serviceGroup}
                serviceType={serviceType}
                serviceGroups={serviceGroups}
                onClearFilter={handleClearFilter}
            />

            {loading ? (
                <Typography sx={{ textAlign: 'center', marginTop: '20px' }}>Đang tải dữ liệu...</Typography>
            ) : (
                <Box style={{ display: "flex", width: '100%', marginTop: '24px', padding: '0px' }}>
                    <Paper style={{ padding: '0px', width: '100%' }}>
                        <Stack direction='row' justifyContent='flex-end' spacing='16px'>
                            <TablePagination
                                rowsPerPageOptions={[20, 30, 40, 50]}
                                component="div"
                                count={total}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </Stack>
                        <TableContainer component={Paper} style={{ overflowY: 'scroll', width: '100%', overflowX: 'scroll', maxHeight: '60vh' }}>
                            <Table stickyHeader>
                                <TableHead sx={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1 }}>
                                    <TableRow>
                                        <StyledTableCell style={{ minWidth: '60px' }}>Mã đơn</StyledTableCell>
                                        <StyledTableCell style={{ minWidth: '80px' }}>Ngày tạo</StyledTableCell>
                                        <StyledTableCell align="right" style={{ minWidth: '120px' }}>Khách hàng</StyledTableCell>
                                        <StyledTableCell align="right" style={{ minWidth: '120px' }}>Liệu trình</StyledTableCell>
                                        <StyledTableCell align="right" style={{ minWidth: '80px' }}>Nhân viên</StyledTableCell>
                                        {/* <StyledTableCell align="right" style={{ minWidth: '80px' }}>Hoa hồng</StyledTableCell> */}
                                        <StyledTableCell align="right" style={{ minWidth: '120px' }}>Tổng giá trị</StyledTableCell>
                                        <StyledTableCell align="right" style={{ minWidth: '120px' }}>Đã thanh toán</StyledTableCell>
                                        <StyledTableCell align="right" style={{ minWidth: '80px' }}>Cửa hàng</StyledTableCell>
                                        <StyledTableCell align="right" style={{ minWidth: '80px', maxWidth: '80px' }}>Trạng thái đơn</StyledTableCell>
                                        <StyledTableCell align="right" style={{ minWidth: '80px', maxWidth: '80px' }}>Ghi chú</StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCell style={{ minWidth: '60px' }} colSpan={5}>Tổng cộng</StyledTableCell>
                                        <StyledTableCell align="right" style={{ minWidth: '120px' }}>{`${convertMoney(totalPrice, true)}`}</StyledTableCell>
                                        <StyledTableCell align="right" style={{ minWidth: '120px' }}>{`${convertMoney(totalPayment, true)}`}</StyledTableCell>
                                        <StyledTableCell align="right" style={{ minWidth: '100px' }}></StyledTableCell>
                                        <StyledTableCell align="right" style={{ minWidth: '100px', maxWidth: '80px' }}></StyledTableCell>
                                        <StyledTableCell align="right" style={{ minWidth: '80px', maxWidth: '80px' }}></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {orders.map((order, index) => (
                                        <OrderItem order={order} key={`${index}-${order.id.toString()}`} changeComission={() => setChangeComissionModal(order)} />
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Box>
            )}

            <FilterModal
                open={filterModalOpen}
                handleClose={() => setFilterModalOpen(false)}
                startDate={startDate}
                endDate={endDate}
                setDateRangeModal={onChangeRange}
                status={status}
                setStatus={setStatus}
                selectedStaffs={selectedStaffs}
                setSelectedStaffs={setSelectedStaffs}
                staffOptions={staffOptions}
                hasPermission={hasPermission}
                authUser={authUser}
                serviceGroup={serviceGroup}
                setServiceGroup={setServiceGroup}
                serviceType={serviceType}
                setServiceType={setServiceType}
                serviceGroups={serviceGroups}
            />

            {changeComission !== null &&
                <AddComissionModal
                    open={changeComission !== null}
                    onChangeComission={onChangeComission}
                    order={changeComission}
                    handleClose={() => {
                        setChangeComissionModal(null)
                    }}
                />
            }

            <DateRangeModal
                open={dateRangeModal}
                startDate={startDate}
                endDate={endDate}
                onConfirm={onChangeRange}
                handleClose={() => {
                    setDateRangeModal(false)
                }}
            />
        </Box>
    )
}

export default Screen